import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert, Badge } from "react-bootstrap";
import { FaPlus, FaTimes, FaEye, FaCheck, FaTrash, FaUser } from "react-icons/fa";
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import AsyncSelect from 'react-select/async';

class PrestadorCentrosReferencia extends Component {
    constructor(props) {
        super(props);

        this.ufOptions = {
            "AC": "Acre", "AL": "Alagoas", "AP": "Amapá", "AM": "Amazonas",
            "BA": "Bahia", "CE": "Ceará", "DF": "Distrito Federal", "ES": "Espírito Santo",
            "GO": "Goiás", "MA": "Maranhão", "MT": "Mato Grosso", "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais", "PA": "Pará", "PB": "Paraíba", "PR": "Paraná",
            "PE": "Pernambuco", "PI": "Piauí", "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul", "RO": "Rondônia", "RR": "Roraima", "SC": "Santa Catarina",
            "SP": "São Paulo", "SE": "Sergipe", "TO": "Tocantins"
        };

        this.state = {
            centrosReferencia: [],
            loading: true,
            loadingModal: false,
            error: '',

            // Seleção de centro existente
            centroSelecionado: null,

            // Modal Criar Centro
            showModalCriar: false,
            novoCentro: {
                nome: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cep: '',
                uf: '',
                cidade: '',
                telefone: '',
                responsavel_recebimento: [], // Array de {nome, telefone}
            },
            novoResponsavelNome: '',

            // Modal Visualizar Centro
            showModalVisualizar: false,
            centroVisualizado: null,

            // Modal Editar Centro
            showModalEditar: false,
            centroEditando: null,
            novoResponsavelEditarNome: '',
        };
    }

    componentDidMount() {
        this.carregarCentrosPrestador();
    }

    carregarCentrosPrestador = () => {
        const { prestadorId } = this.props;

        if (!prestadorId) {
            this.setState({ loading: false, error: 'ID do prestador não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/centros_referencia/prestadores/`, { params: { prestador_id: prestadorId } })
            .then(response => {
                this.setState({
                    centrosReferencia: response.data.results || [],
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                console.error('Erro ao carregar centros de referência:', error);
                this.setState({
                    loading: false,
                    error: 'Erro ao carregar centros de referência',
                });
            });
    };

    // === BUSCA CENTROS EXISTENTES (AsyncSelect) ===
    carregarCentrosReferencia = async (inputValue) => {
        try {
            const response = await api.get(`/centros_referencia/`, { params: { nome: inputValue } });
            const opcoes = response.data.results.map(centro => ({
                value: centro.id,
                label: centro.nome,
                dados: centro,
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar centros de referência:', error);
            return [];
        }
    };

    handleCentroChange = (selectedOption) => {
        this.setState({ centroSelecionado: selectedOption });
    };

    adicionarCentroReferencia = () => {
        const { centroSelecionado, centrosReferencia } = this.state;
        const { prestadorId } = this.props;

        if (!centroSelecionado) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Selecione um centro de referência para adicionar.',
            });
            return;
        }

        // Verifica se já está vinculado
        const jaVinculado = centrosReferencia.some(c => c.centro_referencia_id === centroSelecionado.value);
        if (jaVinculado) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'info',
                title: 'Já vinculado',
                text: 'Este centro de referência já está vinculado a este médico.',
            });
            return;
        }

        this.setState({ loadingModal: true });

        api.post('/centros_referencia/prestadores/', {
            centro_referencia_id: centroSelecionado.value,
            prestador_id: prestadorId
        })
            .then(() => {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Centro de referência vinculado com sucesso.',
                    timer: 2000,
                    showConfirmButton: false
                });
                this.setState({ centroSelecionado: null, loadingModal: false });
                this.carregarCentrosPrestador();
            })
            .catch(error => {
                console.error('Erro ao vincular centro:', error);
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Erro ao vincular centro de referência.',
                });
                this.setState({ loadingModal: false });
            });
    };

    removerCentroReferencia = (relacaoId) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Remover centro?',
            text: 'Tem certeza que deseja remover este centro de referência?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/centros_referencia/prestadores/${relacaoId}/`)
                    .then(() => {
                        MySwal.fire({
                            icon: 'success',
                            title: 'Removido!',
                            text: 'Centro de referência removido.',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        this.carregarCentrosPrestador();
                    })
                    .catch(error => {
                        console.error('Erro ao remover centro:', error);
                        MySwal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Erro ao remover centro de referência.',
                        });
                    });
            }
        });
    };

    // === MODAL CRIAR CENTRO ===
    abrirModalCriar = () => {
        this.setState({
            showModalCriar: true,
            novoCentro: {
                nome: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cep: '',
                uf: '',
                cidade: '',
                telefone: '',
                responsavel_recebimento: [],
            },
            novoResponsavelNome: '',
        });
    };

    fecharModalCriar = () => {
        this.setState({ showModalCriar: false });
    };

    handleNovoCentroChange = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({
            novoCentro: {
                ...prevState.novoCentro,
                [name]: value
            }
        }));
    };

    handleNovoCentroMaskAccept = (fieldName) => (value) => {
        this.setState(prevState => ({
            novoCentro: {
                ...prevState.novoCentro,
                [fieldName]: value
            }
        }));
    };

    onChangeCepNovoCentro = (value) => {
        const cep = value.replace(/\D/g, '');

        this.setState(prevState => ({
            novoCentro: {
                ...prevState.novoCentro,
                cep: cep
            }
        }));

        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(response => response.json())
                .then(data => {
                    if (!data.erro) {
                        this.setState(prevState => ({
                            novoCentro: {
                                ...prevState.novoCentro,
                                endereco: data.logradouro,
                                bairro: data.bairro,
                                cidade: data.localidade,
                                uf: data.uf
                            }
                        }));
                    }
                });
        }
    };

    // Responsáveis - Novo Centro
    handleNovoResponsavelNomeChange = (event) => {
        this.setState({ novoResponsavelNome: event.target.value });
    };

    adicionarResponsavel = () => {
        const { novoResponsavelNome, novoCentro } = this.state;

        if (!novoResponsavelNome.trim()) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Informe o nome do responsável.',
            });
            return;
        }

        this.setState(prevState => ({
            novoCentro: {
                ...prevState.novoCentro,
                responsavel_recebimento: [...prevState.novoCentro.responsavel_recebimento, { nome: novoResponsavelNome.trim(), telefone: '' }]
            },
            novoResponsavelNome: ''
        }));
    };

    removerResponsavel = (index) => {
        this.setState(prevState => ({
            novoCentro: {
                ...prevState.novoCentro,
                responsavel_recebimento: prevState.novoCentro.responsavel_recebimento.filter((_, i) => i !== index)
            }
        }));
    };

    salvarNovoCentro = () => {
        const { novoCentro } = this.state;
        const { prestadorId } = this.props;

        // Validação de campos obrigatórios
        const camposObrigatorios = [
            { campo: 'nome', label: 'Nome' },
            { campo: 'cep', label: 'CEP' },
            { campo: 'endereco', label: 'Endereço' },
            { campo: 'numero', label: 'Número' },
            { campo: 'bairro', label: 'Bairro' },
            { campo: 'cidade', label: 'Cidade' },
            { campo: 'uf', label: 'UF' },
        ];

        const camposFaltando = camposObrigatorios.filter(
            ({ campo }) => !novoCentro[campo] || !String(novoCentro[campo]).trim()
        );

        if (camposFaltando.length > 0) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção',
                html: `Os seguintes campos são obrigatórios:<br/><strong>${camposFaltando.map(c => c.label).join(', ')}</strong>`,
            });
            return;
        }

        this.setState({ loadingModal: true });

        // Prepara dados - converte responsavel_recebimento para JSON se backend esperar string
        const dadosCentro = {
            ...novoCentro,
            responsavel_recebimento: novoCentro.responsavel_recebimento, // Envia como array (JSON)
        };

        // Primeiro cria o centro
        api.post('/centros_referencia/', dadosCentro)
            .then(response => {
                const novoCentroId = response.data.id;
                const novoCentroNome = response.data.nome;

                // Depois vincula ao prestador
                return api.post('/centros_referencia/prestadores/', {
                    centro_referencia_id: novoCentroId,
                    prestador_id: prestadorId
                }).then(() => {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: `Centro "${novoCentroNome}" criado e vinculado com sucesso.`,
                        timer: 2500,
                        showConfirmButton: false
                    });

                    this.setState({
                        loadingModal: false,
                        showModalCriar: false
                    });
                    this.carregarCentrosPrestador();
                });
            })
            .catch(error => {
                console.error('Erro ao criar centro:', error);
                let erro_msg = 'Erro ao criar centro de referência.';

                if (error.response?.data) {
                    const campos = error.response.data;
                    for (let key in campos) {
                        erro_msg += `\n${key}: ${campos[key]}`;
                    }
                }

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: erro_msg,
                });
                this.setState({ loadingModal: false });
            });
    };

    // === MODAL VISUALIZAR CENTRO ===
    abrirModalVisualizar = async (centro) => {
        try {
            // Busca dados completos do centro
            const response = await api.get(`/centros_referencia/${centro.centro_referencia_id}/`);
            this.setState({
                showModalVisualizar: true,
                centroVisualizado: response.data,
            });
        } catch (error) {
            console.error('Erro ao buscar dados do centro:', error);
            // Se falhar, usa os dados que já tem
            this.setState({
                showModalVisualizar: true,
                centroVisualizado: centro.dados_centro,
            });
        }
    };

    fecharModalVisualizar = () => {
        this.setState({ showModalVisualizar: false, centroVisualizado: null });
    };

    // === MODAL EDITAR CENTRO ===
    abrirModalEditar = async (centro) => {
        try {
            const response = await api.get(`/centros_referencia/${centro.centro_referencia_id}/`);
            const dadosCentro = response.data;

            // Garante que responsavel_recebimento seja um array de {nome, telefone}
            let responsavel_recebimento = [];
            if (dadosCentro.responsavel_recebimento) {
                if (typeof dadosCentro.responsavel_recebimento === 'string') {
                    try {
                        const parsed = JSON.parse(dadosCentro.responsavel_recebimento);
                        if (Array.isArray(parsed)) {
                            responsavel_recebimento = parsed.map(item => 
                                typeof item === 'object' 
                                    ? { nome: item.nome || '', telefone: item.telefone || '' }
                                    : { nome: item, telefone: '' }
                            );
                        }
                    } catch (e) {
                        // Se for string simples (formato antigo), converte para array
                        responsavel_recebimento = [{ nome: dadosCentro.responsavel_recebimento, telefone: '' }];
                    }
                } else if (Array.isArray(dadosCentro.responsavel_recebimento)) {
                    responsavel_recebimento = dadosCentro.responsavel_recebimento.map(item =>
                        typeof item === 'object' 
                            ? { nome: item.nome || '', telefone: item.telefone || '' }
                            : { nome: item, telefone: '' }
                    );
                }
            }

            this.setState({
                showModalEditar: true,
                centroEditando: {
                    ...dadosCentro,
                    responsavel_recebimento: responsavel_recebimento,
                },
                novoResponsavelEditarNome: '',
            });
        } catch (error) {
            console.error('Erro ao buscar dados do centro:', error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Erro ao carregar dados do centro de referência.',
            });
        }
    };

    fecharModalEditar = () => {
        this.setState({ showModalEditar: false, centroEditando: null });
    };

    handleCentroEditandoChange = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({
            centroEditando: {
                ...prevState.centroEditando,
                [name]: value
            }
        }));
    };

    handleCentroEditandoMaskAccept = (fieldName) => (value) => {
        this.setState(prevState => ({
            centroEditando: {
                ...prevState.centroEditando,
                [fieldName]: value
            }
        }));
    };

    onChangeCepEditar = (value) => {
        const cep = value.replace(/\D/g, '');

        this.setState(prevState => ({
            centroEditando: {
                ...prevState.centroEditando,
                cep: cep
            }
        }));

        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(response => response.json())
                .then(data => {
                    if (!data.erro) {
                        this.setState(prevState => ({
                            centroEditando: {
                                ...prevState.centroEditando,
                                endereco: data.logradouro,
                                bairro: data.bairro,
                                cidade: data.localidade,
                                uf: data.uf
                            }
                        }));
                    }
                });
        }
    };

    // Responsáveis - Editar Centro
    handleNovoResponsavelEditarNomeChange = (event) => {
        this.setState({ novoResponsavelEditarNome: event.target.value });
    };

    adicionarResponsavelEditar = () => {
        const { novoResponsavelEditarNome, centroEditando } = this.state;

        if (!novoResponsavelEditarNome.trim()) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Informe o nome do responsável.',
            });
            return;
        }

        this.setState(prevState => ({
            centroEditando: {
                ...prevState.centroEditando,
                responsavel_recebimento: [...(prevState.centroEditando.responsavel_recebimento || []), { nome: novoResponsavelEditarNome.trim(), telefone: '' }]
            },
            novoResponsavelEditarNome: ''
        }));
    };

    removerResponsavelEditar = (index) => {
        this.setState(prevState => ({
            centroEditando: {
                ...prevState.centroEditando,
                responsavel_recebimento: prevState.centroEditando.responsavel_recebimento.filter((_, i) => i !== index)
            }
        }));
    };

    salvarEdicaoCentro = () => {
        const { centroEditando } = this.state;

        // Validação de campos obrigatórios
        const camposObrigatorios = [
            { campo: 'nome', label: 'Nome' },
            { campo: 'cep', label: 'CEP' },
            { campo: 'endereco', label: 'Endereço' },
            { campo: 'numero', label: 'Número' },
            { campo: 'bairro', label: 'Bairro' },
            { campo: 'cidade', label: 'Cidade' },
            { campo: 'uf', label: 'UF' },
        ];

        const camposFaltando = camposObrigatorios.filter(
            ({ campo }) => !centroEditando[campo] || !String(centroEditando[campo]).trim()
        );

        if (camposFaltando.length > 0) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção',
                html: `Os seguintes campos são obrigatórios:<br/><strong>${camposFaltando.map(c => c.label).join(', ')}</strong>`,
            });
            return;
        }

        this.setState({ loadingModal: true });

        const dadosCentro = {
            nome: centroEditando.nome,
            endereco: centroEditando.endereco,
            numero: centroEditando.numero,
            complemento: centroEditando.complemento,
            bairro: centroEditando.bairro,
            cep: centroEditando.cep,
            uf: centroEditando.uf,
            cidade: centroEditando.cidade,
            telefone: centroEditando.telefone,
            responsavel_recebimento: centroEditando.responsavel_recebimento,
        };

        api.put(`/centros_referencia/${centroEditando.id}/`, dadosCentro)
            .then(response => {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'Centro de referência atualizado com sucesso.',
                    timer: 2000,
                    showConfirmButton: false
                });

                this.setState({
                    loadingModal: false,
                    showModalEditar: false,
                    centroEditando: null,
                });
                this.carregarCentrosPrestador();
            })
            .catch(error => {
                console.error('Erro ao atualizar centro:', error);
                let erro_msg = 'Erro ao atualizar centro de referência.';

                if (error.response?.data) {
                    const campos = error.response.data;
                    for (let key in campos) {
                        erro_msg += `\n${key}: ${campos[key]}`;
                    }
                }

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: erro_msg,
                });
                this.setState({ loadingModal: false });
            });
    };

    // === HELPERS ===
    parseResponsaveis = (responsavel_recebimento) => {
        if (!responsavel_recebimento) return [];

        if (typeof responsavel_recebimento === 'string') {
            try {
                const parsed = JSON.parse(responsavel_recebimento);
                if (Array.isArray(parsed)) {
                    return parsed.map(item => 
                        typeof item === 'object' 
                            ? { nome: item.nome || '', telefone: item.telefone || '' }
                            : { nome: item, telefone: '' }
                    );
                }
                return [];
            } catch (e) {
                // Formato antigo (string simples)
                return responsavel_recebimento ? [{ nome: responsavel_recebimento, telefone: '' }] : [];
            }
        }

        if (Array.isArray(responsavel_recebimento)) {
            return responsavel_recebimento.map(item => 
                typeof item === 'object' 
                    ? { nome: item.nome || '', telefone: item.telefone || '' }
                    : { nome: item, telefone: '' }
            );
        }

        return [];
    };

    renderResponsaveisBadges = (responsavel_recebimento) => {
        const lista = this.parseResponsaveis(responsavel_recebimento);

        if (lista.length === 0) {
            return <span className="text-muted">-</span>;
        }

        return (
            <div className="d-flex flex-wrap gap-1">
                {lista.slice(0, 2).map((resp, index) => (
                    <Badge key={index} bg="secondary" className="fw-normal">
                        <FaUser className="me-1" size={10} />
                        {resp.nome}
                    </Badge>
                ))}
                {lista.length > 2 && (
                    <Badge bg="light" text="dark" className="fw-normal">
                        +{lista.length - 2}
                    </Badge>
                )}
            </div>
        );
    };

    renderRows = () => {
        const { centrosReferencia } = this.state;

        if (centrosReferencia.length === 0) {
            return null;
        }

        return centrosReferencia.map((centro) => (
            <tr key={centro.id}>
                <td>{centro.dados_centro?.nome || '-'}</td>
                <td>
                    {centro.dados_centro?.endereco
                        ? `${centro.dados_centro.endereco}, ${centro.dados_centro.numero || 's/n'}`
                        : '-'
                    }
                </td>
                <td>
                    {centro.dados_centro?.cidade && centro.dados_centro?.uf
                        ? `${centro.dados_centro.cidade}/${centro.dados_centro.uf}`
                        : '-'
                    }
                </td>
                <td>{centro.dados_centro?.telefone || '-'}</td>
                <td>{this.renderResponsaveisBadges(centro.dados_centro?.responsavel_recebimento)}</td>
                <td>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        className="me-1"
                        onClick={() => this.abrirModalVisualizar(centro)}
                        title="Visualizar"
                    >
                        <FaEye />
                    </Button>
                    <Button
                        variant="outline-primary"
                        size="sm"
                        className="me-1"
                        onClick={() => this.abrirModalEditar(centro)}
                        title="Editar"
                    >
                        <FaUser />
                    </Button>
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={() => this.removerCentroReferencia(centro.id)}
                        title="Remover"
                    >
                        <FaTimes />
                    </Button>
                </td>
            </tr>
        ));
    };

    // === RENDER FORM RESPONSÁVEIS (reutilizável) ===
    renderFormResponsaveis = (responsavel_recebimento, novoNome, onChangeNovo, onAdicionar, onRemover) => {
        return (
            <Card className="mb-3">
                <Card.Header className="bg-light">
                    <strong>Responsáveis pelo Recebimento</strong>
                </Card.Header>
                <Card.Body>
                    {responsavel_recebimento.length > 0 && (
                        <div className="mb-3">
                            {responsavel_recebimento.map((resp, index) => (
                                <Badge 
                                    key={index} 
                                    bg="secondary" 
                                    className="me-2 mb-2 py-2 px-3"
                                    style={{ fontSize: '0.9em' }}
                                >
                                    <FaUser className="me-1" size={12} />
                                    {resp.nome}
                                    <Button
                                        variant="link"
                                        size="sm"
                                        className="p-0 ms-2 text-white"
                                        onClick={() => onRemover(index)}
                                        style={{ lineHeight: 1 }}
                                    >
                                        <FaTimes size={12} />
                                    </Button>
                                </Badge>
                            ))}
                        </div>
                    )}

                    <Row>
                        <Col sm={10}>
                            <Form.Control
                                type="text"
                                placeholder="Nome do responsável"
                                value={novoNome}
                                onChange={onChangeNovo}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onAdicionar();
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={2}>
                            <Button
                                variant="success"
                                onClick={onAdicionar}
                                className="w-100"
                            >
                                <FaPlus className="me-1" /> Adicionar
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    };

    render() {
        const {
            loading,
            loadingModal,
            error,
            centrosReferencia,
            centroSelecionado,
            showModalCriar,
            novoCentro,
            novoResponsavelNome,
            showModalVisualizar,
            centroVisualizado,
            showModalEditar,
            centroEditando,
            novoResponsavelEditarNome,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <h4>Centros de Referência</h4>
                        <p className="text-muted">Vincule este médico a um ou mais centros de referência.</p>

                        <Row className="mb-4">
                            <Col sm={8}>
                                <Form.Group>
                                    <Form.Label>Selecionar Centro de Referência</Form.Label>
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={this.carregarCentrosReferencia}
                                        defaultOptions
                                        name="centro_referencia"
                                        placeholder="Buscar centro de referência..."
                                        noOptionsMessage={() => "Nenhum centro encontrado"}
                                        onChange={this.handleCentroChange}
                                        value={centroSelecionado}
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={4} className="d-flex align-items-end gap-2">
                                <Button
                                    variant="secondary"
                                    onClick={this.adicionarCentroReferencia}
                                    disabled={!centroSelecionado || loadingModal}
                                >
                                    <FaPlus className="me-1" /> Adicionar
                                </Button>
                                <Button
                                    variant="outline-secondary"
                                    onClick={this.abrirModalCriar}
                                >
                                    <FaPlus className="me-1" /> Criar Centro
                                </Button>
                            </Col>
                        </Row>

                        <h5 className="mb-3">Centros Vinculados</h5>
                        {loading ? (
                            <p>Carregando...</p>
                        ) : error ? (
                            <Alert variant="danger">{error}</Alert>
                        ) : centrosReferencia.length === 0 ? (
                            <Alert variant="info">Nenhum centro de referência vinculado a este médico.</Alert>
                        ) : (
                            <Table responsive className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Endereço</th>
                                        <th>Cidade/UF</th>
                                        <th>Telefone</th>
                                        <th>Responsáveis</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderRows()}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>

                {/* Modal Criar Centro */}
                <Modal show={showModalCriar} onHide={this.fecharModalCriar} size="lg" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Criar Centro de Referência</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nome"
                                        placeholder="Nome do centro de referência"
                                        value={novoCentro.nome}
                                        onChange={this.handleNovoCentroChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>CEP <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        as={IMaskInput}
                                        mask="00000-000"
                                        placeholder="CEP"
                                        name="cep"
                                        value={novoCentro.cep}
                                        onAccept={this.onChangeCepNovoCentro}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={7}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Endereço <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="endereco"
                                        placeholder="Endereço"
                                        value={novoCentro.endereco}
                                        onChange={this.handleNovoCentroChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Número <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="numero"
                                        placeholder="Nº"
                                        value={novoCentro.numero}
                                        onChange={this.handleNovoCentroChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Complemento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="complemento"
                                        placeholder="Complemento"
                                        value={novoCentro.complemento}
                                        onChange={this.handleNovoCentroChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Bairro <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="bairro"
                                        placeholder="Bairro"
                                        value={novoCentro.bairro}
                                        onChange={this.handleNovoCentroChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Cidade <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cidade"
                                        placeholder="Cidade"
                                        value={novoCentro.cidade}
                                        onChange={this.handleNovoCentroChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>UF <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="uf"
                                        value={novoCentro.uf}
                                        onChange={this.handleNovoCentroChange}
                                    >
                                        <option value="">UF</option>
                                        {Object.keys(this.ufOptions).map((sigla) => (
                                            <option key={sigla} value={sigla}>{sigla}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col sm={5}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Telefone do Centro</Form.Label>
                                    <Form.Control
                                        as={IMaskInput}
                                        mask="(00) 00000-0000"
                                        placeholder="Telefone"
                                        name="telefone"
                                        value={novoCentro.telefone}
                                        onAccept={this.handleNovoCentroMaskAccept('telefone')}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Responsáveis */}
                        {this.renderFormResponsaveis(
                            novoCentro.responsavel_recebimento,
                            novoResponsavelNome,
                            this.handleNovoResponsavelNomeChange,
                            this.adicionarResponsavel,
                            this.removerResponsavel
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={this.fecharModalCriar}>
                            Cancelar
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={this.salvarNovoCentro}
                            disabled={loadingModal}
                        >
                            {loadingModal ? 'Salvando...' : 'Criar e Vincular'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Visualizar Centro */}
                <Modal show={showModalVisualizar} onHide={this.fecharModalVisualizar} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Detalhes do Centro de Referência</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {centroVisualizado ? (
                            <>
                                <Row>
                                    <Col sm={12}>
                                        <h5>{centroVisualizado.nome}</h5>
                                        <hr />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        <p><strong>Endereço:</strong><br />
                                            {centroVisualizado.endereco ? (
                                                <>
                                                    {centroVisualizado.endereco}, {centroVisualizado.numero || 's/n'}
                                                    {centroVisualizado.complemento && ` - ${centroVisualizado.complemento}`}
                                                    <br />
                                                    {centroVisualizado.bairro && `${centroVisualizado.bairro} - `}
                                                    {centroVisualizado.cidade}/{centroVisualizado.uf}
                                                    <br />
                                                    CEP: {centroVisualizado.cep}
                                                </>
                                            ) : '-'}
                                        </p>
                                    </Col>
                                    <Col sm={6}>
                                        <p><strong>Telefone:</strong><br />{centroVisualizado.telefone || '-'}</p>
                                    </Col>
                                </Row>

                                <h6 className="mt-3"><strong>Responsáveis pelo Recebimento</strong></h6>
                                {(() => {
                                    const responsavel_recebimento = this.parseResponsaveis(centroVisualizado.responsavel_recebimento);
                                    if (responsavel_recebimento.length === 0) {
                                        return <p className="text-muted">Nenhum responsável cadastrado.</p>;
                                    }
                                    return (
                                        <div className="d-flex flex-wrap gap-2">
                                            {responsavel_recebimento.map((resp, index) => (
                                                <Badge 
                                                    key={index} 
                                                    bg="secondary" 
                                                    className="py-2 px-3"
                                                    style={{ fontSize: '0.95em' }}
                                                >
                                                    <FaUser className="me-1" size={12} />
                                                    {resp.nome}
                                                </Badge>
                                            ))}
                                        </div>
                                    );
                                })()}
                            </>
                        ) : (
                            <p>Carregando...</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModalVisualizar}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Editar Centro */}
                <Modal show={showModalEditar} onHide={this.fecharModalEditar} size="lg" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Centro de Referência</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {centroEditando ? (
                            <>
                                <Row>
                                    <Col sm={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nome"
                                                placeholder="Nome do centro de referência"
                                                value={centroEditando.nome}
                                                onChange={this.handleCentroEditandoChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CEP <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                as={IMaskInput}
                                                mask="00000-000"
                                                placeholder="CEP"
                                                name="cep"
                                                value={centroEditando.cep || ''}
                                                onAccept={this.onChangeCepEditar}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={7}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Endereço <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="endereco"
                                                placeholder="Endereço"
                                                value={centroEditando.endereco || ''}
                                                onChange={this.handleCentroEditandoChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Número <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="numero"
                                                placeholder="Nº"
                                                value={centroEditando.numero || ''}
                                                onChange={this.handleCentroEditandoChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Complemento</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="complemento"
                                                placeholder="Complemento"
                                                value={centroEditando.complemento || ''}
                                                onChange={this.handleCentroEditandoChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bairro <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="bairro"
                                                placeholder="Bairro"
                                                value={centroEditando.bairro || ''}
                                                onChange={this.handleCentroEditandoChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cidade <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="cidade"
                                                placeholder="Cidade"
                                                value={centroEditando.cidade || ''}
                                                onChange={this.handleCentroEditandoChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>UF <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="uf"
                                                value={centroEditando.uf || ''}
                                                onChange={this.handleCentroEditandoChange}
                                            >
                                                <option value="">UF</option>
                                                {Object.keys(this.ufOptions).map((sigla) => (
                                                    <option key={sigla} value={sigla}>{sigla}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Telefone do Centro</Form.Label>
                                            <Form.Control
                                                as={IMaskInput}
                                                mask="(00) 00000-0000"
                                                placeholder="Telefone"
                                                name="telefone"
                                                value={centroEditando.telefone || ''}
                                                onAccept={this.handleCentroEditandoMaskAccept('telefone')}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Responsáveis */}
                                {this.renderFormResponsaveis(
                                    centroEditando.responsavel_recebimento || [],
                                    novoResponsavelEditarNome,
                                    this.handleNovoResponsavelEditarNomeChange,
                                    this.adicionarResponsavelEditar,
                                    this.removerResponsavelEditar
                                )}
                            </>
                        ) : (
                            <p>Carregando...</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={this.fecharModalEditar}>
                            Cancelar
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={this.salvarEdicaoCentro}
                            disabled={loadingModal}
                        >
                            {loadingModal ? 'Salvando...' : (
                                <><FaCheck className="me-1" /> Salvar Alterações</>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default PrestadorCentrosReferencia;
